/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
// Wraps the navigation bar and extensionFrames
var mbeExtensionContainer = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
  background: 'transparent !important',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  'padding:': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    left: "var(--ds-space-100, 8px)".concat(" !important"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    right: "var(--ds-space-100, 8px)".concat(" !important")
  },
  paddingBottom: "var(--ds-space-100, 8px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.remove-padding': {
    paddingBottom: 0
  },
  position: 'relative',
  verticalAlign: 'middle',
  cursor: 'pointer',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.multiBodiedExtension-handler-result': {
    marginLeft: "var(--ds-space-100, 8px)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
    display: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
      marginTop: 0
    }
  }
});
var mbeNavigation = css({
  borderTopLeftRadius: "var(--ds-radius-small, 3px)",
  borderTopRightRadius: "var(--ds-radius-small, 3px)",
  userSelect: 'none',
  WebkitUserModify: 'read-only',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
  borderBottom: 'none !important',
  background: "var(--ds-surface, white)",
  marginLeft: "var(--ds-space-100, 8px)",
  marginRight: "var(--ds-space-100, 8px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.remove-margins': {
    margin: "var(--ds-space-negative-100, -8px)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '&.remove-border': {
    border: 'none'
  }
});
var extensionFrameContent = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
  padding: "var(--ds-space-100, 8px)".concat(" !important"),
  display: 'block',
  minHeight: '100px',
  background: 'transparent',
  borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
  borderBottomRightRadius: "var(--ds-radius-small, 3px)",
  marginLeft: "var(--ds-space-100, 8px)",
  marginRight: "var(--ds-space-100, 8px)",
  cursor: 'initial',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.pm-table-with-controls': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    marginLeft: "var(--ds-space-150, 12px)".concat(" !important"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    paddingRight: "var(--ds-space-150, 12px)".concat(" !important")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.bodiedExtensionView-content-wrap': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    marginTop: "var(--ds-space-150, 12px)".concat(" !important")
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '.extensionView-content-wrap': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    marginTop: "var(--ds-space-100, 8px)".concat(" !important")
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var removeMarginsAndBorder = css({
  marginLeft: 0,
  marginRight: 0,
  border: 'none'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var sharedMultiBodiedExtensionStyles = {
  mbeExtensionContainer: mbeExtensionContainer,
  mbeNavigation: mbeNavigation,
  extensionFrameContent: extensionFrameContent
};